import {
  Button,
  ColorPicker,
  Loader,
} from "@screencloud/screencloud-ui-components";
import {
  StylingContainer,
  ThemeConfigContainer,
  ThemePreviewContainer,
  LogoUploader,
  ThemeColorPicker,
  Title,
  LogoUploadButtonContainer,
  ColorPickerContainer,
  ColorPickerPiece,
  SmallText,
  Preview,
  Header,
  Body,
  LineSeparator,
} from "./styles";
import { FormattedMessage } from "react-intl";

export type PresetColors = {
  primary: string;
  secondary: string;
};

interface StylingProps {
  presetColors: PresetColors;
  isUploadingLogo: boolean;
  onPrimaryColorChange: (color: string) => void;
  onSecondaryColorChange: (color: string) => void;
  handleUploadLogo: () => Promise<void>;
  logoThumbnail: string | null;
  isFetchingBrandInfo: boolean;
}

export const Styling = ({
  presetColors,
  isUploadingLogo,
  onPrimaryColorChange,
  onSecondaryColorChange,
  handleUploadLogo,
  logoThumbnail,
  isFetchingBrandInfo,
}: StylingProps) => {
  return (
    <StylingContainer>
      <ThemeConfigContainer>
        <LogoUploader>
          <Title>
            {" "}
            <FormattedMessage
              id="design_my_screen_modal.styling.logo"
              defaultMessage="Logo"
            />
          </Title>
          <LogoUploadButtonContainer>
            <SmallText>
              <FormattedMessage
                id="design_my_screen_modal.styling.logo_recommendation"
                defaultMessage="We recommend uploading a logo with at least 600px width"
              />{" "}
            </SmallText>
            <Button onClick={handleUploadLogo} loading={isUploadingLogo}>
              <FormattedMessage
                id="design_my_screen_modal.styling.upload_logo"
                defaultMessage="Upload Logo"
              />{" "}
            </Button>
          </LogoUploadButtonContainer>
        </LogoUploader>
        <ThemeColorPicker>
          <Title>
            {" "}
            <FormattedMessage
              id="design_my_screen_modal.styling.colors"
              defaultMessage="Colors"
            />
          </Title>
          <ColorPickerContainer>
            <ColorPickerPiece>
              <SmallText>
                {" "}
                <FormattedMessage
                  id="design_my_screen_modal.styling.primary"
                  defaultMessage="Primary"
                />
              </SmallText>
              <ColorPicker
                className="custom-picker"
                color={presetColors.primary}
                onComplete={onPrimaryColorChange}
                disableAlpha
                inlineInput
              />
            </ColorPickerPiece>
            <ColorPickerPiece>
              <SmallText>
                {" "}
                <FormattedMessage
                  id="design_my_screen_modal.styling.secondary"
                  defaultMessage="Secondary"
                />
              </SmallText>
              <ColorPicker
                className="custom-picker"
                color={presetColors.secondary}
                onComplete={onSecondaryColorChange}
                disableAlpha
                inlineInput
              />
            </ColorPickerPiece>
          </ColorPickerContainer>
        </ThemeColorPicker>
      </ThemeConfigContainer>
      <ThemePreviewContainer>
        <Preview color={presetColors.primary}>
          <Header color={presetColors.secondary}>Preview</Header>
          <Body color={presetColors.secondary}>
            The quick brown fox jumps over the lazy dog
          </Body>
          <LineSeparator color={presetColors.secondary} />
          {isFetchingBrandInfo ? (
            <Loader
              data-testid="styling-loader"
              size="small"
              active
              className="thumbnail-loader"
            />
          ) : logoThumbnail ? (
            <img width={50} height={50} src={logoThumbnail} />
          ) : null}
        </Preview>
      </ThemePreviewContainer>
    </StylingContainer>
  );
};
